"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypesStyles = exports.Status = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var HFlow_1 = require("../HFlow");
var Icon_1 = require("../Icon");
var Text_1 = require("../Text");
function Status(props) {
    var type = props.type, text = props.text, style = props.style;
    var _a = styles_1.useStyles(), theme = _a.theme, css = _a.css;
    var typeStyle = exports.createTypesStyles(theme)[type];
    return (react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 0.5, alignItems: 'center', justifyContent: 'flex-start', style: css(typeStyle.style, style) },
        react_1.default.createElement(Icon_1.Icon, { icon: typeStyle.icon, size: 1 }),
        react_1.default.createElement(Text_1.Text, { color: 'inherit' }, text)));
}
exports.Status = Status;
exports.createTypesStyles = function (theme) {
    return {
        info: {
            icon: 'infoCircleOutline',
            style: {
                color: theme.pallete.status.info.main,
            },
        },
        success: {
            icon: 'checkCircleOutline',
            style: {
                color: theme.pallete.status.success.main,
            },
        },
        warning: {
            icon: 'exclamationTriangleOutline',
            style: {
                color: theme.pallete.status.alert.main,
            },
        },
        danger: {
            icon: 'banOutline',
            style: {
                color: theme.pallete.status.danger.main,
            },
        },
    };
};
//# sourceMappingURL=Status.js.map